export default function ServiceElectronicIoT({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <rect x="22" y="22" width="52" height="52" stroke="currentColor" strokeWidth="1.25" />
      <rect x="36" y="36" width="24" height="24" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M48 22 V12 M30 22 V12 M66 22 V12 M48 74 V84 M30 74 V84 M66 74 V84
           M22 48 H12 M22 30 H12 M22 66 H12 M74 48 H84 M74 30 H84 M74 66 H84"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <circle cx="48" cy="48" r="3" fill="#54B53C" />
    </svg>
  );
}
